<template>
  <div
    v-if="menu"
    style="position: relative;padding: 10px 0px;"
    :style="{ background: menu.isShow ? '#f7f7f7' : 'none' }"
  >
    <div
      v-if="isEdit && !menu.isShow"
      style="position: absolute;  top: 0px"
      :style="{ right: right ? right : '-45px' }"
    >
      <div style="display: flex">
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn class="extra-small" color="primary" fab outline v-on="on">
              <v-icon small>build</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="menu.isShow = true">
              <v-list-tile-title class="primary-color">{{ $t('edit') }}</v-list-tile-title>
            </v-list-tile>
            <slot name="append"> </slot>
            <v-list-tile class="primary-color" @click="$emit('onDelete')">
              {{ $t('Delete') }}
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div>
      <div v-if="!menu.isShow" style="padding: 0px 10px">
        <a
          href="javascript:void(0)"
          @click="menu.isShow = true"
          v-if="isEdit"
          style="text-decoration: none"
        >
          {{ menu.title }}
          <!-- <span class="fa fa-pencil-alt"></span> -->
        </a>
        <div v-else>{{ menu.title }}</div>
      </div>
      <div v-else style="text-align:left;" class="form-control">
        <div
          class="form-control"
          style="border-bottom: 1px solid #eee;padding: 10px"
          :class="{ 'has-error': errors.has('buttonName') }"
        >
          <input
            type="text"
            :data-vv-as="$t('Button Name')"
            data-vv-name="buttonName"
            name="buttonName"
            id="buttonName"
            class="form-control"
            :placeholder="$t('Button Name')"
            v-model="menu.title"
            style="width: 100%"
            v-validate="'required'"
            @keyup="onChange"
            maxlength="30"
          />
          <span class="text-error" v-show="errors.has('buttonName')">{{
            errors.first('buttonName')
          }}</span>
        </div>
        <div>
          <v-tabs v-model="step" :slider-color="$vuetify.theme.primary" color="#f7f7f7" show-arrows>
            <v-tab :key="'postback'">
              <i class="fa fa-font"></i>
              <span style="margin-left: 5px;">{{ $t('Text') }}</span>
            </v-tab>
            <v-tab :key="'web_url'">
              <i class="fa fa-link"></i>
              <span style="margin-left: 5px;">{{ $t('Link') }}</span>
            </v-tab>
            <!-- <v-tab :key="'nested'" v-if="hasNested">
              <i class="fa fa-list"></i>
              <span style="margin-left: 5px;">{{$t('Submenu')}}</span>
            </v-tab> -->
            <v-tabs-items touchless>
              <v-tab-item :key="'postback'">
                <div style="padding: 0 10px; margin-top: 5px; margin-bottom: 5px;">
                  <div style="margin-bottom: 15px;margin-top: 15px;">
                    {{
                      $t(
                        'If customer clicks this button, it will send this message to your customer (you can edit the answer in conversation page)'
                      )
                    }}
                  </div>
                  <div class="text-xs-center">
                    <a
                      href="javascript:void(0);"
                      class="btn-advanced"
                      @click="showAdvanced = !showAdvanced"
                    >
                      {{ $t('Advanced') }}
                      <i
                        class="fa"
                        :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
                      ></i>
                    </a>
                  </div>
                  <template v-if="showAdvanced">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errors.has('buttonValue') }"
                      style="margin-top: 15px;"
                    >
                      <input
                        type="text"
                        key="button-value"
                        :data-vv-as="$t('Text')"
                        :data-vv-name="'buttonValue'"
                        class="form-control"
                        :placeholder="$t('Text')"
                        style="width: 100%"
                        v-model="menu.payload"
                        v-validate="menu.type == 'postback' ? 'required' : ''"
                      />
                      <span class="text-error" v-show="errors.has('buttonValue')">{{
                        errors.first('buttonValue')
                      }}</span>
                    </div>
                  </template>
                </div>
              </v-tab-item>
              <v-tab-item :key="'web_url'">
                <div style="padding: 0 10px; margin-top: 5px; margin-bottom: 5px;">
                  <div style="margin-top: 15px; margin-bottom: 15px;">
                    {{
                      $t(
                        'When customer clicks this button, bot will automatically take customer to this link'
                      )
                    }}
                  </div>
                  <p>{{ $t('* Only use https: // or http://') }}</p>
                  <div class="form-control" :class="{ 'has-error': errors.has('buttonLink') }">
                    <textarea
                      type="url"
                      key="button-link"
                      :data-vv-as="$t('Link')"
                      data-vv-name="buttonLink"
                      class="form-control"
                      :placeholder="$t('Link')"
                      style="width: 100%;resize: vertical; height:50px"
                      v-model="menu.url"
                      v-validate="menu.type == 'web_url' ? 'required|isUrl' : ''"
                    ></textarea>
                    <span class="text-error" v-show="errors.has('buttonLink')">{{
                      errors.first('buttonLink')
                    }}</span>
                  </div>
                  <v-btn-toggle v-model="menu.webview_height_ratio">
                    <v-btn flat value="full">full</v-btn>
                    <v-btn flat value="tall">tall</v-btn>
                    <v-btn flat value="compact">compact</v-btn>
                  </v-btn-toggle>
                </div>
              </v-tab-item>
              <v-tab-item :key="'nested'">
                <div style="padding: 0 10px; margin-top: 5px; margin-bottom: 5px;">
                  <p>{{ $t('Create a submenu for this menu item') }}</p>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>

        <div style="padding: 0px 10px;margin-top: 15px">
          <div class="text-xs-center">
            <v-btn outline color="grey" class="ma-0 mr-1 mb-1" @click="onCancel">{{
              $t('cancel')
            }}</v-btn>
            <v-btn depressed color="primary" class="ma-0 mr-1 mb-1" @click="savePersistentButton">{{
              $t('Save')
            }}</v-btn>
          </div>
        </div>
      </div>
    </div>
    <a
      href="javascript:void(0);"
      class="primary-color"
      style="position:absolute;right: 8px;float:left;display: inline-block;top: 50%;margin-top: -10px;"
      v-if="menu.type == 'nested' && !menu.isShow"
      @click="$emit('onSelectNested')"
    >
      <span style="font-size: 10px;vertical-align: text-top;">{{ $t('Edit Sub menu') }}</span>
      <i class="fas fa-chevron-right"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: undefined
    },
    hasNested: {
      default: false
    },
    onEdit: {
      default: false
    },
    right: {
      default: undefined
    }
  },
  data: function() {
    return {
      step: null,
      menu: undefined,
      showAdvanced: false
    }
  },
  mounted: function() {
    var vm = this
    var menu = vm.value
    if (!menu.isShow) {
      menu.isShow = false
    }
    if (menu.type == 'postback') {
      vm.step = 0
    } else if (menu.type == 'web_url') {
      vm.step = 1
    } else if (menu.type == 'nested') {
      vm.step = 2
    }
    vm.menu = Object.assign({}, menu)
    vm.cache_menu = Object.assign({}, menu)
    vm.$nextTick(function() {
      if (vm.menu.type == 'postback') {
        if (vm.menu.title != vm.menu.payload) {
          vm.showAdvanced = true
        }
      }
    })
  },
  computed: {
    isEdit: function() {
      return this.onEdit
    }
  },
  methods: {
    savePersistentButton: function() {
      var vm = this
      this.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        this.menu.isShow = false
        this.cache_menu = Object.assign({}, this.menu)
        this.$emit('input', this.menu)
      })
    },
    setWebviewHeightRatio: function(value) {
      this.menu.webview_height_ratio = value
      this.$forceUpdate()
    },
    onCancel: function() {
      this.menu = Object.assign({}, this.cache_menu)
      this.menu.isShow = false
      if (this.menu.title == '') {
        this.$emit('onDelete')
      }
    },
    onChange: function() {
      if (this.menu.type == 'postback') {
        this.menu.payload = this.menu.title
      }
    }
  },
  watch: {
    value: function() {
      var vm = this
      var menu = this.value

      if (menu.type == 'postback') {
        this.step = 0
      } else if (menu.type == 'web_url') {
        this.step = 1
      } else if (menu.type == 'nested') {
        this.step = 2
      }
      if (!menu.isShow) {
        menu.isShow = false
      }
      this.menu = Object.assign({}, menu)
      this.cache_menu = Object.assign({}, menu)
      vm.$nextTick(function() {
        if (vm.menu.type == 'postback') {
          if (vm.menu.title != vm.menu.payload) {
            vm.showAdvanced = true
          } else {
            vm.showAdvanced = false
          }
        }
      })
    },
    step: function(newVal, oldVal) {
      if (newVal == 0) {
        this.menu.type = 'postback'
      } else if (newVal == 1) {
        this.menu.type = 'web_url'
        this.menu.webview_height_ratio = 'full'
      } else if (newVal == 2) {
        this.menu.type = 'nested'
        if (!this.menu.call_to_actions) {
          this.menu.call_to_actions = []
        }
      }
      this.errors.clear()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/AddButtonPersistentMenu.vue